module.exports = __webpack_public_path__ + "static/ese-logo-dd5ac0b3cf482ae382dce4e9c3f6c2a6.png";